// see https://plonerestapi.readthedocs.io/en/latest/endpoints/users.html?highlight=reset#reset-user-password
// react core
import React from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PasswordStrengthBar from 'react-password-strength-bar';
import { Link } from "react-router-dom";

// components
import UserLogged from 'components/commons/user_logged';
import ForceLogin from 'components/commons/force_login';
import ErrorMessage from 'components/commons/error_msg';
import AjaxSpinner from 'components/commons/ajax_spinner';
import ShowAndHidePassword from 'components/commons/show_hide_pass';

// libs
import { AUTH } from 'api/account';
import { route_to_full_url, ASCIIValid } from 'utils/helpers';
import usePageTitle from 'utils/page_title';

function ButtonSender({ on_click, password, password_check, score })
{
    if (password === password_check && score >= 2 && ASCIIValid(password))
    {
        return (
            <button onClick={on_click} className="button button-primary">Set Password</button>
        )
    }
    else
    {
        return (
            <button disabled className="button button-primary">Set Password</button>
        )
    }
}

function SamePassChecker({ password, password_check })
{
    if (password.length < 3 || password_check.length < 3) return (<div></div>)
    if (password === password_check) return (<div></div>)
    return (
        <div className='auth-form-error-inline'>
            Password doesn't match
        </div>
    )
}

function ValidPassChecker({ password })
{
    if (password.length < 1) return <div>&nbsp;</div>
    if (ASCIIValid(password)) return <div>&nbsp;</div>
    return (
        <div className='passwordchecker'>
            Valid characters are numbers, letters and symbols .!@#$%^&*
        </div>
    )
}

export default function ResetPasswordPage({ user, set_user_data })
{
    usePageTitle('Set Your Password');
    let { username, token } = useParams();
    const [password, set_password] = useState('');
    const [password2, set_password2] = useState('');
    const [score, set_score] = useState(0);
    const [credentials, set_credentials] = useState({});
    const [errors, set_errors] = useState(false);
    const [error_msg, set_error_msg] = useState('');
    const [is_submitted, set_is_submitted] = useState(false);
    const [is_await, set_is_await] = useState(false);

    const handle_submit = (evt) =>
    {
        evt.stopPropagation();
        evt.preventDefault();

        const send_data = async () =>
        {
            const response = await AUTH.reset_user_password(username, token, password);
            if (response.ok)
            {
                set_credentials(
                {
                    username: username,
                    password: password
                });
                set_password('');
                set_password2('');
                set_is_submitted(true);
                set_errors(false);
                set_is_await(false);
            }
            else
            {
                let msg = '';
                switch (response.status)
                {
                    case 400:
                        msg = 'Bad Request';
                        break;
                    case 403:
                        msg = 'Invalid Token';
                        break;
                    case 500:
                        msg = 'Server Error';
                        break;
                    default:
                        msg = 'generic error'
                }
                set_error_msg(msg);
                set_errors(true);
                set_is_await(false);
            }
        }
        // call the function
        set_is_await(true);
        send_data().catch(console.error);

    };
    if (user.ok === true && user.username !== '')
    {
        return (
            <UserLogged />
        )
    }
    else
    {
        const pass_meter_classess =  ASCIIValid(password) ? 'pass_meter' : 'invisible';

        if (is_submitted) return (
            <ForceLogin user={user} credentials={credentials} set_user_data={set_user_data}/>
        );
        else
        {
            let classess = (errors) ? 'auth-form error' : 'auth-form';
            classess += is_await ? ' loading' : '';
            return (<>
                <h2>Set Your Password</h2>
                <p>Your username is: <strong>{username}</strong></p>
                <p>Passwords must contain at least 6 characters and rank as <span style={{color:"#f6b44d"}}>okay</span>. Use a combination of characters, number and symbols for higher ranking </p>
                <AjaxSpinner show={is_await} />
                <form action="#"  className={classess}>
                    <div className='auth-form-errors'>
                            <i className="fa-solid fa-circle-exclamation"></i>
                            <ErrorMessage display={errors} msg={error_msg} />
                    </div>

                    <fieldset>

                    <div className="auth-form-field">
                        <ShowAndHidePassword name="new-password" id="reset-form-new-password"
                                autohide="true"
                                autoComplete="new-password"
                                placeholder="New password"
                                required
                                value={password}
                                onChange={(e) => set_password(e.target.value)}
                            />
                        <label htmlFor="reset-form-new-password">New Password</label>
                        <PasswordStrengthBar
                            className={pass_meter_classess}
                            onChangeScore={(scr) => set_score(scr)}
                            password={password}
                            minLength="6"
                        />
                        <ValidPassChecker password={password} />
                    </div>
                    <div className="auth-form-field">
                    <ShowAndHidePassword name="new-password2" id="reset-form-repeat-password"
                                autohide="true"
                                autoComplete="new-password"
                                required
                                value={password2}
                                placeholder="Confirm password"
                                onChange={(e) => set_password2(e.target.value)}
                            />
                        <label htmlFor="reset-form-repeat-password">Confirm password</label>
                        <SamePassChecker password={password} password_check={password2} />
                    </div>
                    </fieldset>
                        <div className='auth-form-buttons'>
                            <ButtonSender
                                on_click={handle_submit}
                                password={password}
                                password_check={password2}
                                score={score}
                            />
                        </div>
                </form>

                <p>Found your password? <Link className='primary' to={route_to_full_url("login")}>Log in here</Link></p>
                </>);
        }
    }
};
